import * as actionTypes from './actionTypes'

const initialState = {
  routeServices: [],
  sourceCityData: [],
  destCityData: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.OPERATOR_ROUTES_LIST:
      return {
        ...state,
        [payload.fieldType === 'source'? 'sourceCityData': 'destCityData']: payload.data
      }

    case actionTypes.ROUTE_SERVICES: {
      let services = payload.data.body;
      return { ...state, routeServices: services || [] }
    }

    case actionTypes.CLEAR_DRIVER_DETAILS: {
      return {...state, routeServices: []}
    }

    default:
      return state
  }
}
